import React from "react";
import styles from "./PersonalInformation.module.scss";
import ContactCardInformation from "./ContactCardInformation/ContactCardInformation";
import ABOBackground from "./ABOBackground/ABOBackground";
import SuccessionPlan from "./SuccessionPlan/SuccessionPlan";
import BusinessQualitativeComponent from "./BusinessQualitative/BusinessQualitative";
import AwardQualification from "./AwardQualification/AwardQualification";
import { useDocumentsAPI } from "../../CustomHooks/useDocumentAPI";
import GeneralInformation from "../../LeaderProfile/GeneralInformation/GeneralInformation";
import BusinessBackground from "../../LeaderProfile/BusinessBackground/BusinessBackground";
import Recognition from "../../LeaderProfile/Recognition/Recognition";
import BusinessApproach from "../../LeaderProfile/BusinessApproach/BusinessApproach";
import MultipleBusiness from "../../LeaderProfile/MultipleBusiness/MultipleBusiness";
import BCRInformation from "../../LeaderProfile/BCRInformation/BCRInformation";
import FoundationalInfo from "../../LeaderProfile/FoundationalInfo/FoundationalInfo";

interface PersonalInformationProps {
  onChangeTab: (tabId: string) => void;
}

const PersonalInformation: React.FC<PersonalInformationProps> = ({
  onChangeTab,
}) => {
  const successionPlanAPI = useDocumentsAPI("successionPlan");

  return (
    <div
      className={styles.personal_info_wrapper}
      data-testid="leaderInformation_section_testID"
    >
      <div className={`content_inner ${styles.inner_wrapper}`}>
        <div className={styles.section_wrapper}>
          <GeneralInformation />
        </div>

        <div className={styles.section_wrapper}>
          <ContactCardInformation />
        </div>
        <div className={styles.section_wrapper}>
          <FoundationalInfo />
        </div>
        <div className={styles.section_wrapper}>
          <BusinessBackground onChangeTab={onChangeTab} />
        </div>
        <div className={styles.section_wrapper}>
          <MultipleBusiness />
        </div>
        <div className={styles.section_wrapper}>
          <AwardQualification />
        </div>
        <div className={styles.section_wrapper}>
          <BCRInformation />
        </div>
        {/* <div className={styles.section_wrapper}>
          <BusinessQualitativeComponent />
        </div> */}
        {/* Recognition Section Start */}
        <div className={styles.section_wrapper}>
          <Recognition />
        </div>
        {/* Recognition Section Ends */}

        {/* Business Approach Section Start */}
        <div className={styles.section_wrapper}>
          <BusinessApproach />
        </div>
        {/* Business Approach Section Ends */}

        {/* <div className={styles.verticalSection}>
          <div className={styles.vsection_wrapper}>
            <ABOBackground />
          </div>
          <div className={`separator_line ${styles.separator_line}`} />
          <div className={styles.vsection_wrapper}>
            <SuccessionPlan api={successionPlanAPI} />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default PersonalInformation;
